/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import {
  createAPIAction,
} from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('device', [
  'getDevice',
  'updateDevice',
  'deleteDevice',
  'getDeviceData',
  'sendDeviceData',
  'getTxSize',
  'flushTx',
  'getLinks',
  'getDefLinks',
  'getDevices',
  'getRxQOS',
  'countDevices',
  'getRxParamSetupReq',
  'sendRxParamSetupReq',
  'getRxTimingSetupReq',
  'sendRxTimingSetupReq',
  'sendDutyCycleReq',
  'sendDevStatusReq',
  'sendLinkADRReq',
  'sendNewChannelReq',
  'sendUpdChPlanReq',
  'sendUpdChPlanReq2',
  'getMacTxSize',
  'getMacLog',
  'sendDlChannelReq',
  'sendTxParamSetupReq',
  'sendAddBroadcastReq',
  'sendAddBroadcastReqV2',
  'RemoveBroadcastReq',
  'RemoveBroadcastReqV2',
]);

function getDevice(id) {
  return createAPIAction(
    types.getDevice,
    {
      endpoint: `/lora/nodes/${id}`,
    },
  )();
}

function updateDevice(id, data) {
  return createAPIAction(
    types.updateDevice,
    {
      endpoint: `/lora/nodes/${id}`,
      method: 'PUT',
      body: data,
    },
  )();
}

function deleteDevice(id) {
  return createAPIAction(
    types.deleteDevice,
    {
      endpoint: `/lora/nodes/${id}`,
      method: 'DELETE',
    },
  )();
}

function getDeviceData(id, args) {
  return createAPIAction(
    types.getDeviceData,
    {
      endpoint: `/lora/nodes/${id}/samples`,
      method: 'GET',
      query: args,
    },
  )();
}

function sendDeviceData(id, fport, data, encoding) {
  return createAPIAction(
    types.sendDeviceData,
    {
      endpoint: `/lora/nodes/${id}/tx`,
      method: 'POST',
      body: {
        fport,
        data,
        encoding,
      },
    },
  )();
}

function getTxSize(id) {
  return createAPIAction(
    types.getTxSize,
    {
      endpoint: `/lora/nodes/${id}/tx/size`,
      method: 'GET',
    },
  )();
}

function flushTx(id) {
  return createAPIAction(
    types.flushTx,
    {
      endpoint: `/lora/nodes/${id}/tx/flush`,
      method: 'POST',
    },
  )();
}

function getLinks(id) {
  return createAPIAction(
    types.getLinks,
    {
      endpoint: `/lora/nodes/${id}/links`,
    },
  )();
}

function getDefLinks(id) {
  return createAPIAction(
    types.getDefLinks,
    {
      endpoint: `/lora/nodes/${id}/deflink`,
    },
  )();
}

function getDevices(args) {
  return createAPIAction(
    types.getDevices,
    {
      endpoint: '/lora/nodes',
      query: _.assign(
        { sort: '-ctime', pageSize: 10 },
        args,
      ),
    },
  )();
}

function getRxQOS(id) {
  return createAPIAction(
    types.getRxQOS,
    {
      endpoint: `/lora/nodes/${id}/rxqos?download`,
    },
  )();
}

function countDevices(args) {
  return createAPIAction(
    types.countDevices,
    {
      endpoint: '/lora/nodes/count',
      query: args,
    },
  )();
}

function getRxParamSetupReq(id) {
  return createAPIAction(
    types.getRxParamSetupReq,
    {
      endpoint: `/lora/nodes/${id}/mac/args/RXParamSetupReq`,
    },
  )();
}

function sendRxParamSetupReq(id, data) {
  return createAPIAction(
    types.sendRxParamSetupReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/RXParamSetupReq`,
      query: data,
      method: 'POST',
    },
  )();
}

function getRxTimingSetupReq(id) {
  return createAPIAction(
    types.getRxTimingSetupReq,
    {
      endpoint: `/lora/nodes/${id}/mac/args/RXTimingSetupReq`,
    },
  )();
}

function sendRxTimingSetupReq(id, data) {
  return createAPIAction(
    types.sendRxTimingSetupReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/RXTimingSetupReq`,
      query: data,
      method: 'POST',
    },
  )();
}

function sendDutyCycleReq(id, data) {
  return createAPIAction(
    types.sendDutyCycleReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/DutyCycleReq`,
      query: data,
      method: 'POST',
    },
  )();
}

function sendDevStatusReq(id) {
  return createAPIAction(
    types.sendDevStatusReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/DevStatusReq`,
      method: 'POST',
    },
  )();
}

function sendLinkADRReq(id, data) {
  return createAPIAction(
    types.sendLinkADRReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/LinkADRReq`,
      method: 'POST',
      query: data,
    },
  )();
}

function sendNewChannelReq(id, data) {
  return createAPIAction(
    types.sendNewChannelReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/NewChannelReq`,
      method: 'POST',
      query: data,
    },
  )();
}

function sendDlChannelReq(id, data) {
  return createAPIAction(
    types.sendDlChannelReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/DlChannelReq`,
      method: 'POST',
      query: data,
    },
  )();
}

function sendTxParamSetupReq(id, data) {
  return createAPIAction(
    types.sendTxParamSetupReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/TxParamSetupReq`,
      method: 'POST',
      query: data,
    },
  )();
}

function sendUpdChPlanReq(id, data) {
  return createAPIAction(
    types.sendUpdChPlanReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/UpdChPlanReq`,
      method: 'POST',
      query: data,
    },
  )();
}

function sendUpdChPlanReq2(id, data) {
  return createAPIAction(
    types.sendUpdChPlanReq2,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/UpdChPlanReqV2`,
      method: 'POST',
      query: data,
    },
  )();
}

function getMacTxSize(id) {
  return createAPIAction(
    types.getMacTxSize,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/size`,
    },
  )();
}

function getMacLog(id, args) {
  return createAPIAction(
    types.getMacLog,
    {
      endpoint: `/lora/nodes/${id}/mac/logs`,
      query: args,
    },
  )();
}

function sendAddBroadcastReq(id, param) {
  return createAPIAction(
    types.sendAddBroadcastReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/AddBroadcastReq`,
      method: 'POST',
      body: param,
    },
  )();
}

function sendAddBroadcastReqV2(id, param) {
  return createAPIAction(
    types.sendAddBroadcastReqV2,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/AddBroadcastReqV2`,
      method: 'POST',
      body: param,
    },
  )();
}

function RemoveBroadcastReq(id, param) {
  return createAPIAction(
    types.RemoveBroadcastReq,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/RemoveBroadcastReq`,
      method: 'POST',
      body: param,
    },
  )();
}

function RemoveBroadcastReqV2(id, param) {
  return createAPIAction(
    types.RemoveBroadcastReqV2,
    {
      endpoint: `/lora/nodes/${id}/mac/tx/RemoveBroadcastReqV2`,
      method: 'POST',
      body: param,
    },
  )();
}

export default {
  getDevice,
  updateDevice,
  deleteDevice,
  getDeviceData,
  sendDeviceData,
  getTxSize,
  flushTx,
  getLinks,
  getDefLinks,
  getDevices,
  getRxQOS,
  countDevices,
  getRxParamSetupReq,
  sendRxParamSetupReq,
  getRxTimingSetupReq,
  sendRxTimingSetupReq,
  sendDutyCycleReq,
  sendDevStatusReq,
  sendLinkADRReq,
  sendNewChannelReq,
  sendTxParamSetupReq,
  sendDlChannelReq,
  sendUpdChPlanReq,
  sendUpdChPlanReq2,
  getMacTxSize,
  getMacLog,
  sendAddBroadcastReq,
  sendAddBroadcastReqV2,
  RemoveBroadcastReq,
  RemoveBroadcastReqV2,
};




// WEBPACK FOOTER //
// ./src/redux/actions/device.js